import applyBrokerageSession from 'Components/Banking/applyBrokerageSession';

// Reload-Icon in Orderbuch/Depotuebersicht (Chat vom 2026-07-26, Bugreport):
// ist laut globalem Sitzungsstatus (Top-Navigation) fuer GENAU diese
// Verbindung schon eine gueltige Session offen, direkt darueber
// synchronisieren (BrokerageSyncNow, kein PIN/TAN noetig) statt unbedingt den
// vollen Login-Dialog zu zeigen. Ist keine (oder eine andere) Verbindung
// aktiv, oder ist die vermeintlich aktive Session inzwischen doch abgelaufen,
// faellt es auf den normalen Login-Dialog zurueck. onError greift nur bei
// einem echten Fehlschlag (z.B. comdirect-API-Fehler) - fehlt eine gueltige
// Session einfach nur, wird still auf onNeedsLogin zurueckgefallen.
export default function syncBrokerageNow(x, connectionId, { onDone, onNeedsLogin, onError }) {
	// connectionId kommt aus der Verbindungsliste als String, brokerageSession.
	// connectionId vom Server als echte Zahl (intval) - deshalb hier ueber
	// parseInt vergleichen statt strikt (Chat vom 2026-07-26, Bugreport).
	if (x.was.brokerageSession && parseInt(x.was.brokerageSession.connectionId, 10) === parseInt(connectionId, 10)) {
		x.was.axPost('Backend/webapp.php?module=Banking&task=BrokerageSyncNow', { connectionId }, (result) => {
			const content = result.data.content || {};
			if (result.data.returncode === 1) {
				applyBrokerageSession(x, content);
				onDone();
				return;
			}
			if (content.status === 'login-required') {
				onNeedsLogin();
				return;
			}
			if (onError) {
				onError(content.message || 'Synchronisierung fehlgeschlagen.');
				return;
			}
			onNeedsLogin();
		}, () => {
			// Request selbst fehlgeschlagen (Netzwerkfehler, Timeout, ...) - ohne
			// diesen Zweig bliebe der Aufrufer (z.B. syncing-Spinner im Orderbuch)
			// dauerhaft im "läuft noch"-Zustand haengen, da sonst gar kein Callback
			// mehr feuert (siehe axPost in WebappSystem.js).
			if (onError) {
				onError('Synchronisierung fehlgeschlagen (Netzwerkfehler).');
				return;
			}
			onNeedsLogin();
		});
		return;
	}
	onNeedsLogin();
}
